/* Strawhat product page: color carousel, options, live prices, sold-out combos, gallery and Add to Cart.
   Ported from the approved prototype (prototype/pdp.js). Everything you can buy comes live from Shopify
   (the product JSON in the page); option names and values are only tidied for display, e.g. "Pack of 5"
   shows as "5 Pack" and "2.8 inch" as 2.8". The store's own names are untouched. Product pages only. */
(() => {
  const root = document.querySelector('[data-sh-pdp]');
  if (!root) return;
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const $ = (s, el = root) => el.querySelector(s);
  const esc = (s) => String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const PAUSE = '<svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><rect x="6" y="5" width="4" height="14" rx="1"/><rect x="14" y="5" width="4" height="14" rx="1"/></svg>';
  const PLAY = '<svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M8 5.5v13l11-6.5z"/></svg>';
  const kind = root.dataset.kind;

  /* ---------- Option names and values, as the prototype shows them ---------- */
  const KEY = { quantity: 'Pack', pack: 'Pack', size: 'Size', scent: 'Scent', 'color shade': 'Shade', shade: 'Shade', type: 'Type', color: 'Color' };
  const keyOf = (name) => KEY[String(name).toLowerCase().replace(/[^a-z ]/g, '').trim()] || String(name).trim();
  const ORDER = ['Color', 'Size', 'Pack', 'Scent', 'Shade', 'Type'];
  const rank = (k) => (ORDER.indexOf(k) < 0 ? 99 : ORDER.indexOf(k));
  const label = (k, v) => {
    const s = String(v).trim();
    let m;
    if (k === 'Pack' && (m = s.match(/(\d+)/))) return `${m[1]} Pack`;
    if (k === 'Size' && (m = s.match(/^(\d+(?:\.\d+)?)\s*(?:inch|in|")$/i))) return `${m[1]}"`;
    if (k === 'Type') return s.replace(/\s*(?:-\s*\d+\s*pack|\(\s*\d+\s*pack\s*\))$/i, '').replace(/shocktail/i, 'ShockTail');
    return s;
  };
  const sizeNum = (v) => { const m = String(v).match(/^(\d+(?:\.\d+)?)/); return m ? String(parseFloat(m[1])) : ''; };
  const img = (src, w) => (src ? src + (src.includes('?') ? '&' : '?') + 'width=' + w : '');
  const srcOf = (x) => (x ? (typeof x === 'string' ? x : x.src || (x.preview_image && x.preview_image.src) || '') : '');
  // v2.5.3: the square "catalog-<handle>" photo leads for the Shop app, Google and social catalogs only; the
  // product page gallery keeps opening on Johnny's real pack photos.
  const isCatalog = (x) => /\/catalog-[^/?]*$/.test(srcOf(x).split('?')[0]);

  /* ---------- Current product ---------- */
  let D, P;
  const money = (cents) => {
    const f = String(D.moneyFormat || '${{amount}}').replace(/<[^>]*>/g, '');
    const a = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return f.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, a);
  };
  const variants = () => D.product.variants;
  const match = (sel) => variants().find((v) => v.options.every((x, i) => x === sel[i]));
  const availableWith = (i, val) => variants().some((v) => v.available && v.options[i] === val && v.options.every((x, j) => j === i || x === P.sel[j]));
  const optBy = (k) => P.opts.find((o) => o.k === k);

  function load() {
    D = JSON.parse($('[data-sh-json]').textContent);
    ['defaults', 'rig', 'swatches', 'scents'].forEach((k) => { D[k] = D[k] || {}; });
    const pr = D.product;
    const opts = (pr.options || []).map((o, i) => {
      const name = typeof o === 'string' ? o : o.name;
      const values = [];
      pr.variants.forEach((v) => { if (!values.includes(v.options[i])) values.push(v.options[i]); });
      return { i, name, k: keyOf(name), values };
    });
    let start = D.selected && pr.variants.find((v) => v.id === D.selected);
    if (!start) {
      const want = D.defaults || {};
      const fits = pr.variants.filter((v) => opts.every((o) => !want[o.k] || label(o.k, v.options[o.i]) === want[o.k]));
      start = fits.find((v) => v.available) || pr.variants.find((v) => v.available) || fits[0] || pr.variants[0];
    }
    P = { opts, sel: start.options.slice(), qty: 1, photo: 0 };
  }

  /* ---------- Options ---------- */
  function sizeHint(i, v) {
    const pack = optBy('Pack');
    const pool = variants().filter((x) => x.options[i] === v && (!pack || x.options[pack.i] === pack.values[0]));
    if (!pool.length) return '';
    const cents = Math.min(...pool.map((x) => x.price));
    return pack ? `${label('Pack', pack.values[0]).replace(' Pack', ' pk')} ${money(cents)}` : money(cents);
  }
  function paintOpts() {
    const shown = P.opts.filter((o) => o.values.length > 1).sort((a, b) => rank(a.k) - rank(b.k));
    // Keep keyboard focus on the same option button after the buttons are redrawn.
    const box = $('[data-opts]'), had = document.activeElement;
    const keep = had && box.contains(had) && had.classList.contains('sh-pill') ? { i: had.dataset.i, v: had.dataset.v } : null;
    box.innerHTML = shown.map((o) => {
      const cur = P.sel[o.i];
      const pills = o.values.map((v) => {
        const dis = !availableWith(o.i, v);
        const sw = (o.k === 'Color' || o.k === 'Shade') && D.swatches ? D.swatches[v] || (kind === 'merch' ? '#9AA3A8' : '') : '';
        const hint = o.k === 'Scent' ? (D.scents || {})[v] || '' : o.k === 'Size' && kind === 'bait' ? sizeHint(o.i, v) : '';
        return `<button type="button" class="sh-pill${sw ? ' is-sw' : ''}" data-i="${o.i}" data-v="${esc(v)}" aria-pressed="${v === cur}"${dis ? ' disabled' : ''}>` +
          `${sw ? `<i style="--c:${esc(sw)}"></i>` : ''}<span>${esc(label(o.k, v))}${dis ? ' · Sold Out' : ''}</span>` +
          `${hint && !sw ? `<small>${esc(hint)}</small>` : ''}</button>`;
      }).join('');
      return `<div class="sh-opt" role="group" aria-label="${esc(o.k)}"><div class="sh-opt-h"><b>${esc(o.k)}</b><span>${esc(label(o.k, cur))}</span></div><div class="sh-pills">${pills}</div></div>`;
    }).join('');
    if (keep) {
      const same = box.querySelector(`.sh-pill[data-i="${keep.i}"][data-v="${CSS.escape(keep.v)}"]`);
      const next = same && !same.disabled ? same : box.querySelector(`.sh-pill[data-i="${keep.i}"]:not([disabled])`);
      if (next) next.focus();
    }
  }
  function describe() {
    return P.opts.filter((o) => o.values.length > 1).sort((a, b) => rank(a.k) - rank(b.k))
      .map((o) => label(o.k, P.sel[o.i])).join(' · ');
  }
  function paintBuy() {
    const v = match(P.sel);
    P.variant = v;
    const ok = !!(v && v.available);
    const price = $('[data-price]');
    if (v) {
      const d = describe();
      price.innerHTML = `${money(v.price * P.qty)}<small>${P.qty > 1 ? money(v.price) + ' each' + (d ? ' · ' : '') : ''}${esc(d)}</small>`;
    }
    $('[data-qty-out]').textContent = P.qty;
    $('[data-qty-in]').value = P.qty;
    const id = $('[data-variant-id]');
    id.disabled = false;
    if (v) id.value = v.id;
    const add = $('[data-add]');
    add.disabled = !ok;
    add.textContent = ok ? 'Add to Cart' : v ? 'Sold Out' : 'Unavailable';
    // Rig tip (by size) and scent note, after the style's "Chasing" line.
    const specs = $('[data-specs]');
    specs.querySelectorAll('[data-dyn]').forEach((n) => n.remove());
    if (kind === 'bait') {
      const size = optBy('Size'), scent = optBy('Scent');
      const rig = (size && D.rig[sizeNum(P.sel[size.i])]) || D.rigText;
      let html = '';
      if (rig) html += `<dt data-dyn>Rig It</dt><dd data-dyn>${esc(rig)}</dd>`;
      if (scent && (D.scents || {})[P.sel[scent.i]]) html += `<dt data-dyn>Scent</dt><dd data-dyn>${esc(P.sel[scent.i])}: ${esc(D.scents[P.sel[scent.i]].toLowerCase())}</dd>`;
      specs.insertAdjacentHTML('beforeend', html);
    }
    if (kind === 'merch') paintMerchColor();
    syncSticky();
  }
  function paintAll() { paintOpts(); paintBuy(); paintGallery(); }

  /* ---------- Gallery: the product's own photos from Shopify (plus the cutout on bait pages) ---------- */
  let galTimer = null, galPaused = false;
  function shots() {
    const pr = D.product;
    const media = (pr.media || []).filter((m) => srcOf(m) && !isCatalog(m));
    if (kind === 'merch') {
      const c = optBy('Color');
      const used = new Set(pr.variants.map((v) => srcOf(v.featured_image)).filter(Boolean).map((s) => s.split('?')[0]));
      const v = P.variant || match(P.sel);
      const main = v && srcOf(v.featured_image);
      const list = main ? [{ src: main, cap: c ? P.sel[c.i] : '' }] : [];
      // Like the prototype: the chosen color, plus the first photo that isn't a color (the design).
      const design = media.find((m) => !used.has(srcOf(m).split('?')[0]));
      if (design) list.push({ src: srcOf(design), cap: 'Design' });
      return list;
    }
    const n = media.length;
    const list = media.map((m, i) => ({
      src: srcOf(m),
      cap: kind === 'bait' ? (i === 0 ? `Real Pack Photo · ${D.color}` : `Photo ${i + 1} of ${n}`) : D.style === 'forge' ? `Past Forge Batch · ${i + 1} of ${n}` : `Photo ${i + 1} of ${n}`,
    }));
    if (kind === 'bait' && D.cut) list.push({ src: D.cut, cut: true, cap: 'Cutout' });
    return list;
  }
  // The main photo never shows as an empty box: a small copy (the thumbnail size) shows at once behind it,
  // the full photo fades in over it once loaded, and a photo that fails is retried once at a smaller size.
  const key = (u) => String(u || '').replace(/^https?:/, '').split('?')[0];
  function paintGallery() {
    const list = shots();
    if (!list.length) return;
    if (P.photo >= list.length) P.photo = 0;
    const s = list[P.photo];
    const main = $('.sh-gal-main');
    main.style.backgroundImage = s.cut ? 'none' : `url("${img(s.src, 160)}")`;
    let im = main.querySelector('.sh-gal-img');
    if (!im) { im = document.createElement('img'); im.className = 'sh-gal-img'; main.prepend(im); }
    im.classList.toggle('is-cut', !!s.cut);
    const done = () => im.classList.remove('is-loading');
    im.onload = done;
    im.onerror = () => {
      if (!s.cut && im.dataset.retry !== s.src) {
        im.dataset.retry = s.src;
        im.removeAttribute('srcset');
        im.src = img(s.src, 800);
      } else im.classList.add('is-loading'); // keep showing the small copy
    };
    // Keep the photo the page arrived with (or already showing); only load a new one when it changes.
    if (key(im.getAttribute('src')) !== key(s.src)) {
      im.classList.add('is-loading');
      im.removeAttribute('srcset');
      im.removeAttribute('sizes');
      if (s.cut) im.src = s.src;
      else {
        im.sizes = '(max-width: 900px) 92vw, 46vw';
        im.srcset = [500, 800, 1100].map((w) => `${img(s.src, w)} ${w}w`).join(', ');
        im.src = img(s.src, 1100);
      }
    }
    if (im.complete && im.naturalWidth) done();
    im.alt = `${D.product.title}${s.cap ? ', ' + s.cap : ''}`;
    $('[data-gal-cap]').textContent = s.cap;
    const th = $('[data-thumbs]');
    th.innerHTML = list.length > 1 ? list.map((x, i) =>
      `<button type="button" class="${x.cut ? 'is-cut' : ''}" data-shot="${i}" aria-label="${esc(x.cap || 'Photo ' + (i + 1))}" aria-current="${i === P.photo}">` +
      `<img src="${x.cut ? x.src : img(x.src, 160)}" alt="" width="64" height="84"></button>`).join('') : '';
  }
  // Loads a photo before it's shown (used when switching colors), giving up after 3 seconds.
  const preload = (el) => {
    if (!el || !el.getAttribute('src')) return Promise.resolve();
    const im = new Image();
    if (el.getAttribute('sizes')) im.sizes = el.getAttribute('sizes');
    if (el.getAttribute('srcset')) im.srcset = el.getAttribute('srcset');
    im.src = el.getAttribute('src');
    return Promise.race([im.decode().catch(() => {}), new Promise((r) => setTimeout(r, 3000))]);
  };
  function startGal() {
    clearInterval(galTimer);
    if (reduce || galPaused || kind === 'bait' || kind === 'merch') return;
    galTimer = setInterval(() => { const n = shots().length; if (n < 2) return; P.photo = (P.photo + 1) % n; paintGallery(); }, 3800);
  }

  /* ---------- Apparel: the hero shows the chosen color ---------- */
  const hexLum = (h) => { const v = [1, 3, 5].map((i) => parseInt(h.slice(i, i + 2), 16) / 255); return 0.2126 * v[0] + 0.7152 * v[1] + 0.0722 * v[2]; };
  const mix = (a, b, t) => { const p = (h) => [1, 3, 5].map((i) => parseInt(h.slice(i, i + 2), 16)); const x = p(a), y = p(b); return '#' + x.map((v, i) => Math.round(v + (y[i] - v) * t).toString(16).padStart(2, '0')).join(''); };
  function paintMerchColor() {
    const c = optBy('Color');
    if (!c) return;
    const name = P.sel[c.i];
    const dot = (D.swatches || {})[name] || '#9AA3A8';
    const lum = hexLum(dot);
    root.style.setProperty('--tint', lum < 0.25 ? '#E3E6E4' : mix(dot, '#F7F8F5', 0.62));
    root.style.setProperty('--deep', lum < 0.25 ? dot : lum > 0.8 ? '#9AA3A8' : mix(dot, '#0C1A21', 0.3));
    const hc = $('[data-hero-color]'); if (hc) hc.textContent = name;
    const mc = $('[data-merch-color]'); if (mc) mc.textContent = name;
    const v = variants().find((x) => x.options[c.i] === name && srcOf(x.featured_image));
    const g = $('.sh-garment');
    if (g && v) {
      const s = srcOf(v.featured_image);
      g.removeAttribute('srcset');
      g.src = img(s, 1000);
      g.srcset = [500, 800, 1000].map((w) => `${img(s, w)} ${w}w`).join(', ');
      g.alt = `${D.product.title} in ${name}`;
    }
    const dots = $('[data-dots]');
    if (dots && !dots.children.length) {
      dots.innerHTML = c.values.map((val) => `<button type="button" class="sh-dot" data-color="${esc(val)}" aria-label="${esc(val)}" style="--c:${esc((D.swatches || {})[val] || '#9AA3A8')}"><i></i></button>`).join('');
    }
    if (dots) [...dots.children].forEach((b) => b.setAttribute('aria-pressed', b.dataset.color === name ? 'true' : 'false'));
    const cnt = $('[data-count]'); if (cnt) cnt.textContent = `${c.values.length} colors`;
  }
  function setMerchColor(name) {
    const c = optBy('Color');
    if (!c) return;
    P.sel[c.i] = name;
    if (!match(P.sel) || !match(P.sel).available) {
      const v = variants().find((x) => x.available && x.options[c.i] === name);
      if (v) P.sel = v.options.slice();
    }
    P.photo = 0;
    paintAll();
  }

  /* ---------- Bait hero: other colors of the style, loaded in place ---------- */
  const hero = $('[data-pdp-hero]');
  const sibs = () => [...root.querySelectorAll('[data-sib]')];
  const cache = new Map();
  const getSection = (url) => {
    const u = url + (url.includes('?') ? '&' : '?') + 'section_id=' + encodeURIComponent(root.dataset.sectionId);
    if (!cache.has(u)) cache.set(u, fetch(u).then((r) => { if (!r.ok) throw new Error(r.status); return r.text(); }));
    return cache.get(u);
  };
  let busy = false;
  let shown = -1; // index of the color on screen
  const curIndex = () => { if (shown < 0) shown = sibs().findIndex((a) => a.getAttribute('aria-current') === 'true'); return shown; };
  async function swapTo(i, dir) {
    const list = sibs();
    if (busy || !list[i] || i === curIndex()) return;
    busy = true;
    const url = list[i].getAttribute('href');
    // Show the tap at once, then load the new color's page, cutout and main photo before anything
    // leaves the screen, so the hero and the gallery never show an empty box (even on a slow phone).
    list.forEach((a, k) => (k === i ? a.setAttribute('aria-current', 'true') : a.removeAttribute('aria-current')));
    root.setAttribute('aria-busy', 'true');
    let doc;
    try {
      doc = new DOMParser().parseFromString(await getSection(url), 'text/html');
    } catch (e) {
      location.href = url;
      return;
    }
    await Promise.all([preload(doc.querySelector('[data-swap="bait"] img')), preload(doc.querySelector('.sh-gal-img'))]);
    const bait = $('[data-bait]');
    const out = reduce ? null : bait.animate(
      [{ transform: 'none', opacity: 1 }, { transform: `translateX(${-dir * 60}vw) rotate(${-dir * 10}deg)`, opacity: 0 }],
      { duration: 420, easing: 'cubic-bezier(.5,0,.8,.4)', fill: 'forwards' });
    if (out) await out.finished.catch(() => {});
    const oldTitle = $('[data-swap="name"]').dataset.title;
    ['bait', 'name', 'from', 'buy'].forEach((k) => {
      const n = doc.querySelector(`[data-swap="${k}"]`), o = $(`[data-swap="${k}"]`);
      if (n && o) o.replaceWith(n);
    });
    const nm = $('[data-swap="name"]');
    root.style.setProperty('--tint', nm.dataset.tint);
    root.style.setProperty('--deep', nm.dataset.deep);
    if (oldTitle && nm.dataset.title) document.title = document.title.replace(oldTitle, nm.dataset.title);
    history.replaceState(null, '', url);
    shown = i;
    root.removeAttribute('aria-busy');
    load();
    paintAll();
    paintCount();
    const nb = $('[data-bait]');
    const inn = reduce ? null : nb.animate(
      [{ transform: `translateX(${dir * 60}vw) rotate(${dir * 8}deg)`, opacity: 0 }, { transform: 'none', opacity: 1 }],
      { duration: 700, easing: 'cubic-bezier(.15,.85,.25,1)' });
    const done = () => { busy = false; const nx = list[(i + 1) % list.length]; if (nx) getSection(nx.getAttribute('href')).catch(() => {}); };
    if (inn) inn.onfinish = done; else done();
  }
  function paintCount() {
    const cnt = $('[data-count]');
    if (cnt && kind === 'bait') { const n = sibs().length; cnt.textContent = n ? `${n} ${n === 1 ? 'color' : 'colors'}` : ''; }
  }
  function step(d) {
    if (kind === 'bait') {
      const list = sibs(), n = list.length;
      if (n < 2) return;
      const i = curIndex();
      swapTo(((i < 0 ? 0 : i) + d + n) % n, d);
    } else if (kind === 'merch') {
      const c = optBy('Color');
      if (!c) return;
      const i = c.values.indexOf(P.sel[c.i]);
      setMerchColor(c.values[(i + d + c.values.length) % c.values.length]);
    }
  }

  /* No autoplay on product pages (Wheelhouse, 2026-09-30): the page stays on the color the shopper
     opened. Arrows and swatches change color only when tapped. Autoplay stays on the home page hero. */

  /* Fishing line to the bait (cutouts only), bubbles and pointer parallax. */
  if (hero && kind === 'bait') {
    const stage = $('[data-stage]');
    const bb = $('[data-bubbles]');
    if (bb && !reduce) for (let i = 0; i < 12; i++) {
      const s = document.createElement('span'), z = 6 + Math.random() * 14;
      s.style.cssText = `left:${8 + Math.random() * 84}%;width:${z}px;height:${z}px;--drift:${(Math.random() * 60 - 30).toFixed(0)}px;animation-duration:${9 + Math.random() * 10}s;animation-delay:${-Math.random() * 18}s`;
      bb.appendChild(s);
    }
    // The line follows the swimming bait only while the hero is on screen (no redraws off screen).
    let seen = false, lraf = 0;
    const line = () => {
      const l = $('[data-fishline]'), j = $('[data-jig]'), e = $('[data-jig-eye]'), b = $('[data-bait] img');
      if (l && b && getComputedStyle(l.parentNode).display !== 'none') {
        const s = stage.getBoundingClientRect(), r = b.getBoundingClientRect();
        const card = b.classList.contains('sh-bait-card');
        const x = card ? r.left - s.left + r.width * 0.5 : r.left - s.left + r.width * 0.035;
        const y = card ? r.top - s.top + 6 : r.top - s.top + r.height * 0.48;
        l.setAttribute('x1', x); l.setAttribute('y1', -40); l.setAttribute('x2', x); l.setAttribute('y2', y - 14);
        j.setAttribute('cx', x); j.setAttribute('cy', y); e.setAttribute('cx', x); e.setAttribute('cy', y - 12);
        j.style.display = card ? 'none' : ''; e.style.display = card ? 'none' : '';
      }
      lraf = seen ? requestAnimationFrame(line) : 0;
    };
    new IntersectionObserver((es) => {
      seen = es[0].isIntersecting;
      if (seen && !lraf) lraf = requestAnimationFrame(line);
    }).observe(hero);
  }
  if (hero && !reduce) {
    const par = $('[data-bait-par]'), stage = $('[data-stage]');
    stage.addEventListener('pointermove', (e) => {
      const s = stage.getBoundingClientRect(), dx = (e.clientX - s.left) / s.width - 0.5, dy = (e.clientY - s.top) / s.height - 0.5;
      par.style.setProperty('--bx', dx * 28 + 'px'); par.style.setProperty('--by', dy * 18 + 'px');
    });
  }
  /* ---------- Clicks ---------- */
  root.addEventListener('click', (e) => {
    const t = e.target;
    const sib = t.closest('[data-sib]');
    if (sib) {
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.button) return;
      e.preventDefault();
      const i = sibs().indexOf(sib), c = curIndex();
      swapTo(i, i > c ? 1 : -1);
      return;
    }
    const mc = t.closest('[data-color]');
    if (mc) { setMerchColor(mc.dataset.color); return; }
    if (t.closest('[data-next]')) { step(1); return; }
    if (t.closest('[data-prev]')) { step(-1); return; }
    if (t.closest('[data-jump]')) {
      e.preventDefault();
      $('#buy').scrollIntoView({ behavior: reduce ? 'auto' : 'smooth' });
      return;
    }
    const pill = t.closest('.sh-pill');
    if (pill && !pill.disabled) {
      const i = +pill.dataset.i, o = P.opts[i];
      if (kind === 'merch' && o.k === 'Color') { setMerchColor(pill.dataset.v); return; }
      P.sel[i] = pill.dataset.v;
      paintOpts();
      paintBuy();
      if (P.variant) history.replaceState(null, '', `${location.pathname}?variant=${P.variant.id}`);
      return;
    }
    const q = t.closest('[data-qty]');
    if (q) { P.qty = Math.min(20, Math.max(1, P.qty + +q.dataset.qty)); paintBuy(); return; }
    const shot = t.closest('[data-shot]');
    if (shot) { P.photo = +shot.dataset.shot; paintGallery(); galPaused = true; clearInterval(galTimer); syncGalPause(); return; }
    if (t.closest('[data-gal-pause]')) { galPaused = !galPaused; syncGalPause(); startGal(); }
  });
  function syncGalPause() {
    const b = $('[data-gal-pause]');
    if (!b) return;
    b.setAttribute('aria-pressed', galPaused);
    b.setAttribute('aria-label', galPaused ? 'Play the photo slideshow' : 'Pause the photo slideshow');
    b.innerHTML = galPaused ? PLAY : PAUSE;
  }

  /* ---------- Add to Cart: into Dawn's cart drawer ---------- */
  root.addEventListener('submit', async (e) => {
    const form = e.target.closest('[data-buy-form]');
    if (!form) return;
    e.preventDefault();
    const btn = $('[data-add]'), err = $('[data-buy-error]');
    if (btn.disabled || !P.variant) return;
    const drawer = document.querySelector('cart-drawer');
    const body = { id: P.variant.id, quantity: P.qty };
    if (drawer) {
      body.sections = drawer.getSectionsToRender().map((s) => s.id);
      body.sections_url = location.pathname;
      drawer.setActiveElement(btn);
    }
    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');
    btn.textContent = 'Adding…';
    syncSticky();
    err.hidden = true;
    try {
      const r = await fetch(window.routes.cart_add_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(body),
      });
      const res = await r.json();
      if (res.status) {
        err.textContent = res.description || res.message || 'Couldn’t add that to the cart.';
        err.hidden = false;
        return;
      }
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'sh-product', productVariantId: P.variant.id, cartData: res });
      }
      if (drawer) {
        drawer.classList.remove('is-empty');
        drawer.renderContents(res);
      } else location.href = window.routes.cart_url;
      P.qty = 1;
    } catch (x) {
      err.textContent = 'Couldn’t add that to the cart. Please try again.';
      err.hidden = false;
    } finally {
      btn.removeAttribute('aria-busy');
      paintBuy();
      // The button was disabled while adding, which drops keyboard focus. If the cart drawer didn't take
      // it, put it back on the button (e.g. after an error) so keyboard users don't land at the top.
      if (!document.querySelector('cart-drawer.active') && (document.activeElement === document.body || !document.activeElement)) {
        const again = $('[data-add]');
        if (again) again.focus();
      }
    }
  });

  /* ---------- Sticky Add to Cart (phones): a slim bar while the main button is out of view ---------- */
  // Lives outside the swapped part of the page, so it survives color changes; it always acts on the
  // current main button, so price, stock and adding stay exactly the same.
  function stickyBar() {
    if (!stickyBar.el) {
      const el = document.createElement('div');
      el.className = 'sh-stickybuy';
      el.hidden = true;
      el.setAttribute('role', 'region');
      el.setAttribute('aria-label', 'Quick Add to Cart');
      el.innerHTML = '<span class="sh-stickybuy-price" data-sticky-price></span><button type="button" class="sh-btn" data-sticky-add>Add to Cart</button>';
      el.querySelector('[data-sticky-add]').addEventListener('click', () => {
        const add = $('[data-add]');
        if (add && !add.disabled) add.click();
      });
      document.body.appendChild(el);
      stickyBar.el = el;
    }
    return stickyBar.el;
  }
  function syncSticky() {
    const el = stickyBar(), add = $('[data-add]');
    if (!add) return;
    const b = el.querySelector('[data-sticky-add]');
    b.disabled = add.disabled;
    b.textContent = add.textContent.trim();
    if (add.hasAttribute('aria-busy')) b.setAttribute('aria-busy', 'true'); else b.removeAttribute('aria-busy');
    el.querySelector('[data-sticky-price]').textContent = P && P.variant ? money(P.variant.price * P.qty) : '';
    placeSticky();
  }
  function placeSticky() {
    const el = stickyBar(), add = $('[data-add]'), foot = document.querySelector('.sh-foot');
    if (!add) return;
    const r = add.getBoundingClientRect();
    const out = r.bottom < 0 || r.top > window.innerHeight;
    const nearFoot = foot && foot.getBoundingClientRect().top < window.innerHeight;
    el.hidden = !(window.matchMedia('(max-width: 749px)').matches && out && !nearFoot);
  }
  let stickyTick = 0;
  const onScroll = () => { if (!stickyTick) stickyTick = requestAnimationFrame(() => { stickyTick = 0; placeSticky(); }); };
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);

  /* ---------- Reveal on scroll (the Keep Shopping cards) ---------- */
  const liftIO = new IntersectionObserver((es) => es.forEach((x) => {
    if (x.isIntersecting) { x.target.classList.add('is-in'); liftIO.unobserve(x.target); }
  }), { rootMargin: '0px 0px -8% 0px' });
  document.querySelectorAll('.sh-lift').forEach((el) => liftIO.observe(el));

  load();
  paintAll();
  paintCount();
  startGal();
  if (kind === 'bait') { const list = sibs(), i = curIndex(); if (list.length > 1) getSection(list[(i + 1) % list.length].getAttribute('href')).catch(() => {}); }
})();

// v2.5.1: Judge.me writes its buttons and labels in sentence case; show them in Title Case (site text rule).
(() => {
  const w = document.querySelector('.jdgm-widget'); if (!w) return;
  const T = { 'Write a review': 'Write a Review', 'Cancel review': 'Cancel Review', 'Review content': 'Review Content', 'Display name': 'Display Name', 'Email address': 'Email Address', 'Picture/Video (optional)': 'Picture/Video (Optional)', 'Sort by': 'Sort By' };
  const fix = () => {
    const it = document.createTreeWalker(w, NodeFilter.SHOW_TEXT); let n;
    while ((n = it.nextNode())) { const t = n.nodeValue.trim(); if (T[t]) n.nodeValue = n.nodeValue.replace(t, T[t]); }
  };
  fix(); new MutationObserver(fix).observe(w, { childList: true, subtree: true });
})();
